import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFObject from "PDFLib/core/objects/PDFObject";

export class PrecompiledRawStringItem extends JSONItemBase{
    GetType() {
        return 'PR'
    }



    constructor(public Text:string) {
        super();
    }
}